module.exports = __webpack_public_path__ + "img/re_seria_2.f54d2654.png";